import { toast } from "react-toastify";
import baseApi from "../../../API/baseApi";
import routes from "../../../API/routes";

export async function listarResultados(filtros) {
    try {
        const response = await baseApi.get(`${routes.resultados.listarResultados}`, filtros);

        if (response.data.success) {
            return response.data.data;
        } else {
            toast.error(response.data.message || 'Ocorreu um erro ao recuperar os resultados.');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao recuperar os resultados.');
        return null;
    }
}

export async function excluirResultado(cpf, competencia) {
    try {
        const response = await baseApi.deletar(`${routes.resultados.excluirResultado}?cpf=${cpf}&competencia=${encodeURIComponent(competencia)}`);

        if(response.data.success){
            toast.success(response.data.message || 'Resultado excluído com sucesso!');
            return { sucesso: true };
        }else{
            toast.error(response.data.message || 'Ocorreu um erro ao excluir o resultado');
            return { sucesso: false };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao excluir o resultado');
        return { sucesso: false };
    }   
}

export async function exportarRelatorio(cpf) {
    try {
        const response = await baseApi.get(`${routes.resultados.exportarRelatorio}`, { cpf: cpf }, {
            responseType: "blob",
        });

        if (response.data) {
            const data = response.data;

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `relatorio-apuracao-${cpf}.xlsx`);
            document.body.appendChild(link);
            link.click();

            toast.success('Relatório gerado com sucesso.');
            return { sucesso: true };
        }else {
            toast.error(response.data.message || 'Erro ao gerar relatório.');
            return { sucesso: false, mensagem: response.data.message || 'Erro ao gerar relatório.' };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Erro ao gerar relatório.');
        return { sucesso: false, mensagem: errorMessage || 'Erro ao gerar relatório.' };
    }
}

export async function listarDetalhado(filtros) {
    try {
        const response = await baseApi.get(`${routes.resultados.listarResultadosDetalhado}`, filtros);

        if (response.data.success) {
            return response.data.data;
        } else {
            toast.error(response.data.message || 'Ocorreu um erro ao recuperar o resultado detalhado.');
            return null;
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Ocorreu um erro ao recuperar o resultado detalhado.');
        return null;
    }
}

export async function exportarRelatorioDetalhado(filtros) {
    try {
        const response = await baseApi.get(`${routes.resultados.exportarRelatorioDetalhado}`, filtros, {
            responseType: "blob",
        });

        if (response.data) {
            const data = response.data;

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `relatorio-${filtros.considerado ? 'considerados' : 'nao-considerados'}-${filtros.competencia}-${filtros.cpf}.xlsx`);
            document.body.appendChild(link);
            link.click();

            toast.success('Relatório gerado com sucesso.');
            return { sucesso: true };
        }else {
            toast.error(response.data.message || 'Erro ao gerar relatório.');
            return { sucesso: false, mensagem: response.data.message || 'Erro ao gerar relatório.' };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Erro ao gerar relatório.');
        return { sucesso: false, mensagem: errorMessage || 'Erro ao gerar relatório.' };
    }
}

export async function exportarRelatorioDetalhadoCompleto(filtros) {
    try {
        const response = await baseApi.get(`${routes.resultados.exportarRelatorioDetalhadoCompleto}`, filtros, {
            responseType: "blob",
        });

        if (response.data) {
            const data = response.data;

            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `relatorio-de-detalhamento-${filtros.cpf}.xlsx`);
            document.body.appendChild(link);
            link.click();

            toast.success('Relatório gerado com sucesso.');
            return { sucesso: true };
        }else {
            toast.error(response.data.message || 'Erro ao gerar relatório.');
            return { sucesso: false, mensagem: response.data.message || 'Erro ao gerar relatório.' };
        }
    } catch (e) {
        const errorMessage = e.response && e.response.data && e.response.data.message;
        toast.error(errorMessage || 'Erro ao gerar relatório.');
        return { sucesso: false, mensagem: errorMessage || 'Erro ao gerar relatório.' };
    }
}

